import React from "react";
import {EditNameForm, NameDto} from "./EditNameForm";
import {useEditorLocation} from "../editor/editor.hook";
import {LabeledTextDisplay} from "./LabeledTextDisplay";

type InputType = NameDto & { id: string };

interface EditableNameProps<T extends InputType> {
    onSubmit: (entityId: string, dto: NameDto) => Promise<any>;
    value?: T;
    className?: string
}

export function EditableName<T extends InputType>({value, onSubmit, className}: EditableNameProps<T>) {

    const {mode, reference} = useEditorLocation();
    const showNameForm = mode === 'edit' && reference === 'name';
    const fullName = value ? `${value.salutation} ${value.firstName} ${value.lastName}` : undefined;

    return showNameForm && value
        ? (
            <EditNameForm
                initialValues={{
                    firstName: value.firstName,
                    lastName: value.lastName,
                    salutation: value.salutation
                }}
                onSubmit={(dto) => onSubmit(value.id, dto)}
                className={className}
            />
        )
        : (
            <LabeledTextDisplay
                label="Name"
                type="name"
                required
                editIdentifier="name"
                value={fullName}
                className={className}
            />
        )
}

